import WebappStorageCipherProxy from './WebappStorageCipherProxy';

/**
 * Amplify v6 requires an async `KeyValueStorageInterface` for the Cognito token
 * provider (`cognitoUserPoolsTokenProvider.setKeyValueStorage`). This is a thin
 * async wrapper over the existing synchronous encrypt/decrypt proxy so the token
 * storage stays encrypted at rest, exactly like the v5 `Auth.storage` setup.
 *
 * The underlying sync proxy is kept intact because `oidc-client`'s
 * `WebStorageStateStore` (see config/oauth.ts) still expects the synchronous
 * `Storage`-like shape.
 */
export default class AsyncWebappStorageCipherProxy {
    private readonly proxy: WebappStorageCipherProxy;

    constructor(storage: Storage) {
        this.proxy = new WebappStorageCipherProxy(storage);
    }

    async setItem(key: string, value: string): Promise<void> {
        this.proxy.setItem(key, value);
    }

    async getItem(key: string): Promise<string | null> {
        return this.proxy.getItem(key);
    }

    async removeItem(key: string): Promise<void> {
        this.proxy.removeItem(key);
    }

    async clear(): Promise<void> {
        this.proxy.clear();
    }
}
